var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "image-tint",
    class: _vm.getTintStyle,
    style: { opacity: _vm.tintStrength / 100 },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }